module.exports = __webpack_public_path__ + "static/media/attachIcon.9a403e35.svg";